import Truncate from 'react-truncate';
import { Information2 } from '../common/icons';
import { history } from '../../store';

const ProductsItem = (props) => {
  const {
    brand,
    link,
    image,
    name,
    rsp
  } = props;
  const isMobileScreen = window.innerWidth <= 768;

  return (
    <div>
      <div className="carousel-item">
        {isMobileScreen && (
          <div>
            {link ? (
              <a href={link} className="overlay" target="_blank">
                <div className="brand">{brand}</div>
                <Truncate className="product-name" lines={2} ellipsis={<span>...</span>}>
                  {name}
                </Truncate>
                <div>RRP: £{rsp}</div>
                <div className="more-info">More Info</div>
              </a>
            ) : (
              <div className="overlay">
                <div className="brand">{brand}</div>
                <Truncate className="product-name" lines={2} ellipsis={<span>...</span>}>
                  {name}
                </Truncate>
                <div>RRP: £{rsp}</div>
              </div>
            )}
          </div>
        )}
        <div className="information"><Information2 height={18} width={18} /></div>
        <img src={image} alt={name} />
      </div>
      {!isMobileScreen && (
        <div
          className="carousel-item-title"
          onClick={() => {
            if (link) {
              history.push(link);
            }
          }}
        >
          {brand}
          <br />
          {name}
          <br />
          RRP: £{rsp}
        </div>
      )}
    </div>
  );
};

export default ProductsItem;
